export default "__VITE_ASSET__XxHDALFs__"